<template>
    <div v-if="property.video_url" class="md:mt-8">
        <fwb-heading tag="h3" class="only-dest font-medium text-xl">
            Video

        </fwb-heading>
      <div class="bg-white w-full shadow-md rounded-lg overflow-hidden md:mt-4">
        <!-- Video local -->
        <video
          v-if="property.video_type === 'file'"
          class="w-full h-64 md:h-96 object-cover"
          :src="property.video_url"
          controls
        >
          Tu navegador no soporta la reproducción de videos.
        </video>
  
        <!-- Video URL incrustado -->
        <iframe
          v-else-if="property.video_type === 'url'"
          class="w-full h-64 md:h-96 object-cover"
          :src="embedVideoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue'; // Importar correctamente 'computed'
  import { FwbHeading } from "flowbite-vue";
  const props = defineProps({
    property: {
      type: Object,
      required: true,
    },
  });
  
  // Convertir URLs a enlaces de incrustación válidos
  const embedVideoUrl = computed(() => {
    if (props.property.video_type === 'url') {
      
  
      // Si no es YouTube, devolver la URL original
      return props.property.video_url;
    }
  
    return null;
  });
  </script>
  
  <style scoped>
  /* Personaliza los colores de Tuin si es necesario */
  .text-tuin_base-500 {
    color: #4CAF50; /* Ejemplo de color base */
  }
  </style>
